import { useEffect, useState } from 'react'

// import pinchtozoom from '../../../assets/images/pinchtozoom.png'
import logoNacer from '../../../assets/images/logo-nacer.webp'
import freshFxLogo from '../../../assets/images/freshFxLogo.png'
import freshFxFeaturing from '../../../assets/images/freshFxFeaturing.png'
import before from '../../../assets/images/freshfxBefore.PNG'
import getStartedImage from '../../../assets/images/getStartedImage.gif'

import Footer from '../../Footer/Footer'
import { BiArrowBack } from 'react-icons/bi'

const Freshfxdashboard = () => {
  const [loading, setLoading] = useState(true)
  // const [showPopupTayaraProject, setShowTayaraProjectPopup] = useState(true)

  useEffect(() => {
    import('./projects.css')
      .then(() => setLoading(false)) // CSS is imported, stop loading
      .catch(() => setLoading(false)) // In case of error, stop loading as well
  }, [])

  return (
    <div>
      {/* {showPopupTayaraProject && (
        <div
          class="showpopup"
          onClick={(e) => {
            if (e.target !== e.currentTarget) return
            handleCloseOnboardingTayaraProject()
          }}
        >
          <img
            src={pinchtozoom}
            alt="pinch to zoom project images"
            className="NavigationGuide"
          />
          <button onClick={() => handleCloseOnboardingTayaraProject()}>
            Skip
          </button>
        </div>
      )} */}
      {loading ? (
        <div class="spinner-wrap-on-loading">
          <div className="loading-container">
            <img className="logo-on-loading" src={logoNacer} alt="" />
            <div class="spinner-item"></div>
            <div class="spinner-item spinner-item--2"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="bg-black font-sans overflow-hidden">
            <header class="header">
              <a href="https://nacermediouni.vercel.app/">
                <img class="logo" src={logoNacer} alt="" />
              </a>
            </header>
            <div className="absolute flex flex-col z-[9999] top-11 right-6 md:right-12 w-fit h-fit">
              <a
                className=" flex gap-4 items-center text-sm font-bold  text-white hover:text-neutral-500 "
                href="https://nacer-mediouni.netlify.app/works"
              >
                <BiArrowBack size={20} />
                Back to projects
              </a>
              <span className="relative left-10 bottom-3 rotate-90 w-[1px] h-10 bg-[#00ffc6]"></span>
            </div>
            <div className="w-full h-screen bg-[url('/src/assets/images/featuringFreshFXDash.png')] bg-no-repeat bg-cover lg:bg-cover lg:bg-fixed  bg-center ">
              <div className="absolute inset-0 z-10 w-full h-screen bg-black/80 ">
                <div className="w-full h-full flex flex-col items-center justify-center gap-6">
                  {/* <h1 className="text-6xl font-extrabold">Tayara</h1> */}
                  <img
                    src={freshFxLogo}
                    alt="tayara-project-logo"
                    className=""
                  />

                  <p className="mx-4 lg:mx-[15%] text-base lg:text-xl text-center font-medium">
                    FreshFX Sports Dashboard Redesign
                  </p>
                  <div className="w-full absolute bottom-10">
                    <div class="scd">
                      <div class="chv"></div>
                      <div class="chv"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-slate-50 text-black ">
              <div className="w-full flex flex-col gap-4">
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Role</h1>
                  <span className="text-base">UX/UI Designer</span>
                </div>
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Settings</h1>
                  <span className="text-base">
                    Freelance project with FreshFX
                  </span>
                </div>
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Timeline</h1>
                  <span className="text-base">2 Weeks</span>
                </div>
              </div>
            </div>

            <div className="w-full h-full pt-10 pb-1 px-[10%] md:px-[20%] bg-white text-neutral-600 ">
              <div className="w-full flex justify-between items-center flex-wrap gap-4">
                <div className="w-fit my-4">
                  <h1 className="text-2xl md:text-3xl font-extrabold">
                    FreshFX sports dashboard redesign
                  </h1>
                  {/* <h1 className="text-base md:text-xl font-extrabold my-2">
                    #1 Most visited Tunisian Classified Marketplace
                  </h1> */}
                </div>
                {/* <a
                  href="https://rdv.biat.com.tn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" p-4 text-sm lg:text-base text-white font-medium bg-neutral-800 hover:bg-transparent hover:text-neutral-800 border-2 border-neutral-800"
                >
                  View final product
                </a> */}
              </div>
              <img
                src={freshFxFeaturing}
                className="w-full my-10 rounded-3xl border-[1px] border-neutral-100"
                alt="Biat project"
              />
              {/* <p className="text-base md:text-lg  font-normal font-sans my-10">
                The project required redesigning a data-intensive dashboard to
                improve the visualization of groups, benchmarks, and data
                manipulation features, ultimately making it easier for users to
                access and interpret key performance metrics. It allows them to
                monitor various data points such as distance covered, high
                metabolic load, and exertion levels across multiple players in
                real-time. Each section of the dashboard is thoughtfully
                structured to highlight trends and comparisons, with color-coded
                indicators that help users quickly assess performance.
                Interactive features enable users to sort, filter, and adjust
                benchmarks, providing an adaptable, at-a-glance view of each
                player's progress and performance.
              </p> */}

              <div className="w-full justify-between items-center my-10 md:my-14">
                <h1 className="text-xl md:text-2xl font-extrabold my-4">
                  Role & Project
                </h1>
                <p className="text-base md:text-lg">
                  In this project, I undertook the redesign of a sports
                  performance dashboard with the goal of making data more
                  accessible, interpretable, and actionable for users. The
                  original dashboard, while functional, lacked clarity and ease
                  of use, particularly when it came to visualizing player
                  groups, benchmarks, and interactive data manipulation. My
                  objective was to create a visually engaging, user-centered
                  interface that simplified complex data, improved usability,
                  and allowed for scalable, reusable components that developers
                  could easily implement. Using Figma, I crafted a solution that
                  enhances both the visual and interactive aspects of the
                  dashboard, resulting in a more efficient and insightful user
                  experience.
                </p>
                <div className=" ">
                  {/* Before/After Comparison */}
                  <div className="mb-8">
                    <h1 className="text-xl md:text-2xl font-extrabold my-10">
                      Before/After Comparison
                    </h1>
                    <div className="mb-4">
                      <h3 className="text-lg font-semibold my-4">
                        Before the redesign
                      </h3>
                      <p className="text-base md:text-lg">
                        The original dashboard layout presents player
                        performance metrics in a tabular format. Key performance
                        indicators such as "Distanz," "HMLD," "HSR," and "EXP"
                        are displayed for each player, segmented into Acute and
                        Chronic values with an A/C ratio. The data is
                        color-coded to indicate performance relative to a
                        benchmark. However, the design lacks clarity in data
                        grouping, making it challenging for users to identify
                        patterns or focus on individual players. Additionally,
                        the minimal use of visual hierarchy and lack of
                        graphical elements require users to interpret
                        performance solely through text and color.
                      </p>
                      <h3 className="text-lg font-semibold my-4">
                        Key challenges in the original design
                      </h3>
                      <ul className="list-disc text-base ">
                        <li className="my-2">
                          <b>Lack of Visual Grouping:</b> Players are not
                          visually grouped, making it difficult to assess
                          team-level data.{' '}
                        </li>
                        <li className="my-2">
                          <b>Complex Benchmarking:</b> The color-coding system
                          for benchmarking is not immediately clear, limiting
                          the effectiveness of "at-a-glance" data
                          interpretation.
                        </li>{' '}
                        <li className="my-2">
                          <b>Basic Table Layout:</b> The rigid table structure
                          limits data interaction and editing, potentially
                          affecting usability for actions like updating or
                          deleting data.
                        </li>{' '}
                        <li className="my-2">
                          <b>Absence of Individual Player Insights:</b> Users
                          cannot access detailed views for individual players,
                          restricting in-depth analysis.
                        </li>
                      </ul>
                    </div>
                    <div className="w-full flex flex-col my-8 justify-center mx-auto">
                      <img
                        src={before}
                        className="w-full rounded-3xl border-[1px] border-neutral-100"
                        alt="Initial dashboard"
                      />
                      <span className=" my-4 text-center text-base text-neutral-400">
                        Original dashboard layout
                      </span>
                    </div>

                    <div className="mb-4">
                      <h3 className="text-lg font-bold my-4">
                        After the redesign
                      </h3>
                      <p className="text-base md:text-lg">
                        In the redesigned dashboard, the layout is improved with
                        enhanced visual hierarchy, clearer data grouping, and a
                        more intuitive color scheme. The new design uses
                        interactive elements, charts, and iconography to
                        simplify data analysis. A single-player data screen can
                        now be accessed, offering detailed insights into
                        individual player performance.
                      </p>
                      <h3 className="text-lg font-bold my-4">
                        Improvements in the redesigned dashboard
                      </h3>
                      <ul className="list-disc text-base ">
                        <li className="my-2">
                          <b>Enhanced Data Grouping:</b> Players are grouped
                          more clearly, with visual cues that make it easier for
                          users to differentiate between teams and quickly
                          locate individual players.
                        </li>
                        <li className="my-2">
                          <b>Simplified Benchmarking:</b> Benchmark values are
                          presented in a more intuitive manner, with visual
                          indicators (e.g., icons, arrows) to help users assess
                          whether a player's performance is above or below the
                          benchmark.
                        </li>{' '}
                        <li className="my-2">
                          <b>Interactive Table Component:</b> The table layout
                          is updated to support inline editing, uploading, and
                          deletion of data, making it easier for users to manage
                          and interact with performance metrics.
                        </li>{' '}
                        <li className="my-2">
                          <b>Single Player Data Screen:</b> The addition of a
                          player-specific detail page provides a deeper dive
                          into individual statistics, enhancing usability for
                          coaches and analysts who need to focus on a single
                          player's progress.
                        </li>
                      </ul>
                    </div>

                    <h1 className="text-xl md:text-2xl font-extrabold my-10">
                      Wireframes
                    </h1>

                    <div className="relative flex justify-center items-center w-full h-full">
                      {/* <div className="absolute top-0 w-full bg-black h-[4rem] z-50 "></div> */}
                      <iframe
                        className=" w-full px-[10%] md:px-[0%] md:w-full h-screen"
                        src="https://embed.figma.com/design/BkQxOYeBBBmrgyHoeMab2w/FreshFxDashboard?node-id=0-1&embed-host=share"
                        allowfullscreen
                        title="work"
                      ></iframe>

                      <div className="absolute bottom-0 w-full bg-white h-[50px] z-50 "></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Visuals */}
            <div className="w-full h-full pb-10 px-[10%] md:px-[20%] bg-white text-neutral-600 ">
              <h1 className="text-xl md:text-2xl font-extrabold mb-4">
                Prototypes
              </h1>
            </div>

            <div className="relative w-full h-full mt-10">
              <div className="absolute bottom-1 w-full bg-black h-[50px] z-50 "></div>

              <iframe
                title="work"
                className="relative w-full h-[20rem] md:h-screen"
                src="https://embed.figma.com/proto/BkQxOYeBBBmrgyHoeMab2w/FreshFxDashboard?node-id=175-62340&node-type=canvas&scaling=scale-down-width&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=175%3A62340&show-proto-sidebar=1&embed-host=share"
                allowfullscreen
              ></iframe>
            </div>

            {/* After the Project */}
            <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-white text-neutral-600 ">
              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                  Final thoughts and takeaways
                </h2>
                <div className="mb-4">
                  <h3 className="text-lg font-semibold my-4">
                    Challenges faced
                  </h3>
                  <blockquote className="border-l-4 border-neutral-100 pl-4 text-base">
                    Balancing data density with visual clarity was a major
                    challenge. Ensuring that users could interpret data at a
                    glance without overwhelming them with too much information
                    required careful attention to layout and color usage.
                  </blockquote>
                </div>
                <div className="mb-4">
                  <h3 className="text-lg font-semibold my-4">Learnings</h3>
                  <blockquote className="border-l-4 border-neutral-100 pl-4 text-base">
                    This project highlighted the importance of intuitive data
                    visualization and user-friendly design in a data-heavy
                    interface. Working closely with developers to create
                    modular, reusable components was also a valuable experience,
                    reinforcing the need for collaboration in design and
                    development.
                  </blockquote>
                </div>
                <div className="mb-4">
                  <h3 className="text-lg font-semibold my-4">Next steps</h3>
                  <blockquote className="border-l-4 border-neutral-100 pl-4 text-base">
                    For future iterations, I would explore more advanced data
                    filtering options and consider adding predictive insights or
                    data trend analysis to further enhance user experience.
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <div className=" bg-black flex flex-col md:flex-row justify-start items-center ">
        <img src={getStartedImage} alt="get started" className="w-[50%]" />
        <div className="w-full h-full gap-10 flex flex-col justify-center items-center md:items-start mx-auto pb-20 md:pb-0">
          <p className="text-3xl lg:text-5xl md:w-[90%] px-[10%] md:px-0 text-center md:text-start font-semibold">
            Want to build remarkable products together?
          </p>
          <a
            href="https://www.linkedin.com/in/nacermediouni/"
            aria-label="Linkedin"
            target="_blank"
            rel="noreferrer"
            className=" text-2xl lg:text-3xl text-[#00ffc6] font-bold underline underline-offset-2 hover:underline-offset-1"
          >
            Let's get strated!
          </a>
        </div>
      </div>

      <div className="  w-full flex flex-col justify-center items-center pt-20 pb-8 px-[10%] md:px-[20%] font-sans bg-white">
        <Footer />
      </div>
    </div>
  )
}

export default Freshfxdashboard
